import { render, staticRenderFns } from "./DoctorReviewSlide.vue?vue&type=template&id=1938b46b&"
import script from "./DoctorReviewSlide.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorReviewSlide.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1938b46b')) {
      api.createRecord('1938b46b', component.options)
    } else {
      api.reload('1938b46b', component.options)
    }
    module.hot.accept("./DoctorReviewSlide.vue?vue&type=template&id=1938b46b&", function () {
      api.rerender('1938b46b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/mobile/DoctorReviewSlide.vue"
export default component.exports